import React from 'react';
import { BarChart, Bar, XAxis, YAxis, LabelList, CartesianGrid, Tooltip, Legend, 
    Label, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { colorsCombination, setCurrencyFormat } from '../../../../utils/helpers';

const SubscribersBarChart = ({dir, height, dataToPlot, index }) => {
    const [color1] = colorsCombination[(index) % 10];    
    const viewerStyle = {
        display: "block",
        margin: "0 auto",
        width: "70vw",
        height: "90vh"
      };
      
      const pageStyle = {
        paddingTop: 20,
        paddingHorizontal: 40,
        paddingBottom: 40
      };
   
    return (
        // <Col xs={12}>
        // <Card >
        //     <CardBody style={{ marginTop: '50px' }}>
                <ResponsiveContainer className="dvPdf" width="100%" height={height} style={{ marginTop: '50px' }}>
                    <BarChart
                        width={500}
                        height={400}
                        data={dataToPlot}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                        <XAxis dataKey="date" reversed={dir === 'rtl'} />
                        <YAxis yAxisId="left" type="number" allowDataOverflow>
                        <Label angle={-90} value="Value"
                        position='insideLeft' style={{ textAnchor: 'middle' }} />
                        </YAxis>               
                        <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(0), false)} />
                        <Legend />
                        <Bar
                                            stackId="count"
                                            yAxisId="left"
                                            // fill={color1}
                                            fill="#F5BD61"
                                            dataKey={"noOfSubscriptions"?.toString()}
                                            stroke="#000000"
                                            barSize={40}
                                        ><LabelList dataKey="noOfSubscriptions" 
                                        formatter={value => setCurrencyFormat(Number(value).toFixed(0), false)} 
                                        position="inside" textAnchor="top" angle="-90" 
                                        style={{fontSize: '11px', fontWeight: 'bold', fill: 'black'}}  /></Bar>
                    </BarChart>
                </ResponsiveContainer>
         
        //         </CardBody>
        //     </Card>
        // </Col>
    )
}

SubscribersBarChart.propTypes = {
    dir: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    index: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
};

SubscribersBarChart.defaultProps = {
    index: 0
  }

export default React.memo(SubscribersBarChart);